import React from 'react';
import ReactDOM from 'react-dom';
import { useEscapeKey } from '../hooks/useEscapeKey';
import '../styles/CollaborationInfoModal.css';

function CollaborationInfoModal({ isOpen, onClose }) {
  useEscapeKey(isOpen, onClose);

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content collab-info-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>About Collaboration Lists</h2>
          <button className="btn-close" onClick={onClose}>✕</button>
        </div>

        <div className="collab-info-content">
          <div className="collab-info-section">
            <div className="collab-info-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                <circle cx="9" cy="7" r="4"/>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
              </svg>
            </div>
            <div className="collab-info-text">
              <h4>Shared Places</h4>
              <p>Everyone on this list can add and remove places. All collaborators see the same places.</p>
            </div>
          </div>

          <div className="collab-info-section">
            <div className="collab-info-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                <path d="M12 20h9"/>
                <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/>
              </svg>
            </div>
            <div className="collab-info-text">
              <h4>Personal Designations</h4>
              <p>Your designations and notes are displayed to you. Other collaborators have their own.</p>
            </div>
          </div>

          <div className="collab-info-section">
            <div className="collab-info-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                <circle cx="12" cy="12" r="3"/>
              </svg>
            </div>
            <div className="collab-info-text">
              <h4>View Collaborators' Info</h4>
              <p>Tap the place card to see what other collaborators have saved about the place.</p>
            </div>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}

export default CollaborationInfoModal;
